import { VisitorsTabContainer } from './VisitorsTabContainer';

export default VisitorsTabContainer;
